import ButtonBase from '@material-ui/core/ButtonBase';
import { styled } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { tooltipClasses } from '@mui/material/Tooltip';
import clsx from 'clsx';
import { useMemo } from 'react';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import { getLinkCDNVideo } from 'utils/ImageUtils';
import { checkVideoUrl } from 'utils/video';
import useDetailPriceStates from 'zustand-lib/useProductDetailPrices';
import SimpleVideoPlayer from '../SimpleVideoPlayer';
import styles from './styles.module.css';

const TITLE_REMOVE_WISHLIST = 'Bỏ đánh dấu sản phẩm';
const TITLE_ADD_WISHLIST = 'Đánh dấu sản phẩm quan tâm';

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#A2A0A0',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#A2A0A0',
    color: '#fff',
    fontSize: 12,
    top: '-2px',
  },
}));
const CardImage = ({
  img,
  onClickQuestion,
  onClickWhistList,
  isWish,
  onClickImage,
  hiddenIconAndText = false,
  isNotAuth,
  hasModal = false,
  alt = '',
}) => {
  const { isFirstTimeAccessPDP = false } = useDetailPriceStates();
  const isVideoUrl = useMemo(() => {
    return checkVideoUrl(img) ?? false;
  }, [img]);

  const handleClickQuestion = (e) => {
    onClickQuestion(e);
  };
  const handleClickWhistList = (e) => {
    onClickWhistList(e);
  };
  const handleOpenModal = () => {
    if (hiddenIconAndText && isNotAuth) return null;
    return onClickImage();
  };
  return (
    <div className={clsx(styles.container, hasModal && styles.containerModal)}>
      <div className={clsx(styles.image, isVideoUrl ? 'flex items-center' : '')}>
        {hiddenIconAndText ? null : (
          <>
            <div className={styles.tooltipLeft} onClick={handleClickQuestion}>
              <LightTooltip title="Thắc mắc về sản phẩm " arrow placement="top">
                <div className={styles?.customButton}>
                  <HelpOutlineIcon className={styles.icon} style={{ fontSize: 24, color: '#00000033' }} />
                </div>
              </LightTooltip>
            </div>
            <div className={styles.tooltipRight} onClick={handleClickWhistList}>
              <LightTooltip title={isWish ? TITLE_REMOVE_WISHLIST : TITLE_ADD_WISHLIST} arrow placement="top">
                <div className={styles?.customButton}>
                  {isWish ? (
                    <FavoriteIcon style={{ fontSize: 24, color: 'var(--primary-color)' }} />
                  ) : (
                    <FavoriteBorderIcon className={styles.icon} style={{ fontSize: 24, color: '#00000033' }} />
                  )}
                </div>
              </LightTooltip>
            </div>
          </>
        )}
        <ButtonBase onClick={handleOpenModal} className="openImg">
          {isVideoUrl ? (
            <SimpleVideoPlayer
              src={getLinkCDNVideo(img)}
              width={360}
              height={360}
              isCenterPlayButton={false}
              isAutoPlay={isFirstTimeAccessPDP}
            />
          ) : (
            <ImageFallbackProductImage width={360} height={360} src={img} quality={100} objectFit="contain" alt={alt} />
          )}
        </ButtonBase>
      </div>
    </div>
  );
};
export default CardImage;
